import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CategoryType } from '@core/shared/domain';
import { CategoryBase, ValueCache } from '@mpcm/shared';

import { ArticleRangeService } from './article-range.service';

class CategoryCacheServiceImpl extends ValueCache<CategoryBase, string> {
  constructor(
    private readonly articleRangeService: ArticleRangeService,
    private readonly categoryType: CategoryType,
  ) {
    super();
  }

  protected getKey(value: CategoryBase): string {
    return value.code;
  }

  protected getValuesByKey(keys: readonly string[]): Observable<readonly CategoryBase[]> {
    return this.articleRangeService.getCategories(this.categoryType, { codes: keys });
  }
}

@Injectable()
export class CategoryCacheService {
  private readonly _services: Partial<Record<CategoryType, CategoryCacheServiceImpl>> = {};

  constructor(private readonly articleRangeService: ArticleRangeService) {}

  public for(categoryType: CategoryType): CategoryCacheServiceImpl {
    return (this._services[categoryType] ??= new CategoryCacheServiceImpl(this.articleRangeService, categoryType));
  }
}
